module.exports = __webpack_public_path__ + "img/microphone-alt.5bacb4a3.svg";